import { Fragment } from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Helmet } from "react-helmet-async";
import { styled } from "@mui/material/styles";
import { Link, Container, Typography, Grid } from "@mui/material";
import useResponsive from "../../../hooks/useResponsive";
import Logo from "../../../components/Logo";
import LanguagePopover from "../../../layouts/dashboard/header/LanguagePopover";

const StyledRoot = styled("div")(({ theme }) => ({
  [theme.breakpoints.up("md")]: {
    display: "flex",
  },
}));

const StyledSection = styled("div")(({ theme }: any) => ({
  width: "100%",
  maxWidth: 480,
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  boxShadow: theme.customShadows.card,
  backgroundColor: theme.palette.background.default,
}));

const StyledContent = styled("div")(({ theme }) => ({
  maxWidth: 480,
  margin: "auto",
  minHeight: "100vh",
  display: "flex",
  justifyContent: "center",
  flexDirection: "column",
  padding: theme.spacing(12, 0),
}));

export const ClientVerified = () => {
  const { t } = useTranslation();
  const mdUp = useResponsive("up", "md");
  const navigate = useNavigate();

  return (
    <Fragment>
      <Helmet>
        <title>{`${t("VerifyOrganization")} | ${t("AppTitle")}`}</title>
      </Helmet>

      <StyledRoot>
        <Logo
          sx={{
            position: "fixed",
            top: { xs: 16, sm: 24, md: 40 },
            left: { xs: 16, sm: 24, md: 40 },
          }}
        />
        {mdUp && (
          <StyledSection>
            <Grid sx={{ top: "10%", position: "fixed", maxWidth: "480px" }}>
              <Typography variant="h3" sx={{ px: 5, mt: 10 }}>
                {t("Get Verified")}
              </Typography>
              <img
                style={{
                  marginLeft: "8%",
                  maxWidth: "80%",
                }}
                src="/assets/illustrations/verified.png"
                alt=""
              />
            </Grid>
          </StyledSection>
        )}

        <Container maxWidth="sm">
          <StyledContent>
            <Fragment>
              <Typography variant="h4" sx={{ color: "#02540b" }}>
                {t("YourOrganizationIsVerified")}
              </Typography>

              <Typography variant="h5" sx={{ mt: 2, mb: 2 }}>
                {t("StoreYourSecurityCode")}
              </Typography>

              <Typography variant="h5">
                <Link
                  variant="h5"
                  sx={{ cursor: "pointer" }}
                  onClick={() => navigate("/login")}
                >
                  {t("PleaseLoginNow")}
                </Link>
              </Typography>
            </Fragment>
          </StyledContent>
        </Container>
      </StyledRoot>

      <span style={{ position: "fixed", top: "10px", right: "10px" }}>
        <LanguagePopover />
      </span>
    </Fragment>
  );
};
